import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Pagination from "./Pagination/Pagination";
import Navigation from "./Navigation/Navigation";
import { register } from "swiper/element/bundle";
register();

const Swiper = (props) => {
  const {
    children,
    className,
    paginationClassName,
    navigationClassName,
    numberOfSlides,
    ...rest
  } = props;

  const [activeIndex, setActiveIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState();

  const swiperRef = useRef();

  const nextSlideHandler = () => {
    swiperInstance.slideNext();
  };

  const prevSlideHandler = () => {
    swiperInstance.slidePrev();
  };

  const jumpToSlideHandler = (index) => {
    const currentActive =
      index * (Number(swiperInstance.params.slidesPerView) || 1);
    swiperInstance.slideTo(currentActive);
    setActiveIndex(currentActive);
  };

  useEffect(() => {
    const swiperNode = swiperRef.current;

    const settings = {
      ...rest,
      on: {
        slideChange(swiper) {
          setActiveIndex(swiper.activeIndex);
        },
      },
    };

    Object.assign(swiperNode, settings);
    swiperNode.initialize();
    setSwiperInstance(swiperNode.swiper);
  }, [rest]);

  return (
    <>
      <swiper-container init="false" ref={swiperRef} class={className}>
        {children}
      </swiper-container>
      <Pagination
        numberOfSlides={numberOfSlides}
        slidesPerView={swiperInstance?.params.slidesPerView}
        activeIndex={activeIndex}
        onPageClick={jumpToSlideHandler}
        className={paginationClassName}
      />
      <Navigation
        onNext={nextSlideHandler}
        onPrev={prevSlideHandler}
        className={navigationClassName}
      />
    </>
  );
};

export default Swiper;

Swiper.propTypes = {
  className: PropTypes.string,
  paginationClassName: PropTypes.string,
  navigationClassName: PropTypes.string,
  numberOfSlides: PropTypes.number,
};
